import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useBusiness } from '../contexts/BusinessContext';

const RoleBasedDashboardRedirect = () => {
  const navigate = useNavigate();
  const { businessId } = useParams();
  const { activeBusiness } = useBusiness();

  useEffect(() => {
    if (activeBusiness && businessId) {
      // Get user role from active business
      const userRole = activeBusiness.user_role || activeBusiness.role;
      
      // Redirect based on role
      if (userRole === 'OWNER' || userRole === 'ADMIN') {
        navigate(`/business/${businessId}/dashboard/owner`, { replace: true });
      } else if (userRole === 'STAFF') {
        navigate(`/business/${businessId}/dashboard/staff`, { replace: true });
      } else {
        // Default to owner dashboard
        navigate(`/business/${businessId}/dashboard/owner`, { replace: true });
      }
    }
  }, [activeBusiness, businessId, navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-gray-600">Redirecting to dashboard...</div>
    </div>
  );
};

export default RoleBasedDashboardRedirect;
